import { Injectable, Provider } from '@angular/core';

@Injectable({ providedIn: 'root' })
export abstract class LibraryConfigurationProvider {
  abstract get config(): LibraryConfiguration;
}
export class LibraryConfiguration {
    config?: Provider;
}
